export default __webpack_public_path__ + "static/media/luna-de-miel.0ffdd1d7.jpg";